<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<header>
<h1 class="FM-Head-fmh"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><span href="#/xhtml/contents#c_ack" id="ack" title="Link target outside of Sample"><b>ACKNOWLEDGMENTS</b></span></span></h1>
</header>
<p class="Chap-Opening-Text-No-Indent-cotx1">I am deeply indebted to Paul Stevens at the Donald Maass Literary Agency, for his calm and steady guidance. To the entire staff at St. Martin’s Press, especially my brilliant editor, Peter Wolverton, who knew he wanted a sequel from the very beginning. My additional thanks to the talented Jennifer Donovan, Joe Brosnan, Sarah Bonamino, Hannah O’Grady, Sophia Dembling, Norma Hoffman, and Niko Eickelbeck.</p>
<p class="Text-Standard-tx">To Lauren Szurgot with the William Morris Agency, who shares the vision.</p>
<p class="Text-Standard-tx">I cannot express my gratitude enough to the bookstore owners and staff, the book clubs, and my family and friends who embraced these novels. And to the writers who’ve offered support along the way, especially Michael Koryta, J. T. Ellison, and Hank Phillippi Ryan, I am forever thankful.</p>
<p class="Text-Standard-tx">To Kathleen and Steve Morris, family who are our closest friends. Thank you for bringing Peter and Nick into the world so I could write about redheads.</p>
<p class="Text-Standard-tx">To Michael Morris, for the fact-checking.</p>
<p class="Text-Standard-tx">To Todd Wrubel, for helping to develop a character that proves there is good even in the most notorious of troublemakers.</p>
<p class="Text-Standard-tx">To Todd Doughty, an extraordinary publicist and an even better friend.</p>
<p class="Text-Standard-tx">To my brother Jason Finley, for your edits and extensive knowledge of aliens.</p>
<p class="Text-Standard-tx"><span aria-label="viii" id="pg_viii" role="doc-pagebreak">To my daughters Eve and Charlotte. You make me proud to be your father.</span></p>
<p class="Text-Standard-tx">And to my wife, Rebecca, whose grace, kindness, grit, beauty, intelligence, and love proves in the story of my life, the hero is a woman.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?8c9e1818